import { combineReducers } from '@reduxjs/toolkit';

import { baseSlice } from '@/shared';
import { authSlice } from '@/modules/auth';
import { profileSlice } from '@/modules/profile';
import { withdrawalsSlice } from '@/modules/withdrawals';
import { paymentsSlice } from '@/modules/payments/store/payments-slice';

import { baseApi } from '@/shared';

export const rootReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  [baseSlice.name]: baseSlice.reducer,
  [authSlice.name]: authSlice.reducer,
  [profileSlice.name]: profileSlice.reducer,
  [withdrawalsSlice.name]: withdrawalsSlice.reducer,
  [paymentsSlice.name]: paymentsSlice.reducer,
});
